import { render, staticRenderFns } from "./SearchFilterSection.vue?vue&type=template&id=48edf134&scoped=true"
import script from "./SearchFilterSection.vue?vue&type=script&lang=js"
export * from "./SearchFilterSection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48edf134",
  null
  
)

export default component.exports